// extracted by mini-css-extract-plugin
export default {"gridBtn":"style-module--gridBtn--AoDr8","modal":"style-module--modal--qIgrS"};